export const LOAD_MYREPORTS = 'reports/LOAD_MYREPORTS';
export const LOAD_REPORTS = 'reports/LOAD_REPORTS';
export const LOAD_COMPLIANCE_REPORTS = 'reports/LOAD_COMPLIANCE_REPORTS';

export const REPORTS_LOADING = 'reports/REPORTS_LOADING';
export const DETAILS_LOADING = 'reports/DETAILS_LOADING';
export const SET_REPORTS_SELECTEDYEAR = 'reports/SET_REPORTS_SELECTEDYEAR';

export const LOAD_DELEGATED_REPORTS = 'reports/LOAD_DELEGATED_REPORTS';
export const LOAD_WAITING_REPORTS = 'reports/LOAD_WAITING_REPORTS';
export const SET_REPORTS_APPROVALORDER = 'reports/SET_REPORTS_APPROVALORDER';

export const SET_SELECTED_DETAIL_REPORT_DIRTY = 'reports/SET_SELECTED_DETAIL_REPORT_DIRTY';
export const LOAD_REPORTDETAILS = 'reports/LOAD_REPORTDETAILS';

export const SET_REPORTS_SELECTEDTAB = 'reports/SET_REPORTS_SELECTEDTAB';




